module.exports = __webpack_public_path__ + "static/img/bouncebloodorangegrapefruit_th.0e16950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/bouncebloodorangegrapefruit_th.png
// module id = w111
// module chunks = 0